<app-dialog-container (onClose)="closeDialog()">
    <div class="flex flex-col lg:min-h-[600px] min-h-[80vh] justify-center gap-4 md:px-0 sm:px-6">
        <form [formGroup]="applyForm" *ngIf="!submitted">
            <div class="md:max-h-[50vh] max-h-[80vh] overflow-y-auto">
                <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6 mb-4">{{ job.title }}</h1>
                <p *ngIf="error" class="text-red-500 block text-sm font-medium leading-6 mb-4" i18n>
                    Sorry, there was an issue processing your application. Please check your submission and try again
                    shortly.
                </p>
                <div class="flex flex-col gap-4 border-b border-gray-900/10 pb-8">
                    <div class="grow">
                        <label for="firstName" class="block text-sm font-medium leading-6" i18n
                            >First Name<sup>*</sup></label
                        >
                        <input
                            formControlName="firstName"
                            placeholder="Your Name"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="
                                !applyForm.get('firstName')?.pristine &&
                                applyForm.get('firstName')?.hasError('required')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your first name.
                        </div>
                    </div>
                    <div class="grow">
                        <label for="lastName" class="block text-sm font-medium leading-6" i18n
                            >Last Name(s)<sup>*</sup></label
                        >
                        <input
                            formControlName="lastName"
                            placeholder="Your Name"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="
                                !applyForm.get('lastName')?.pristine && applyForm.get('lastName')?.hasError('required')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your last name(s).
                        </div>
                    </div>
                    <div class="grow">
                        <label for="email" class="block text-sm font-medium leading-6" i18n
                            >Email Address<sup>*</sup></label
                        >
                        <input
                            formControlName="email"
                            placeholder="Email Address"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="!applyForm.get('email')?.pristine && applyForm.get('email')?.hasError('required')"
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your email address.
                        </div>
                        <div
                            *ngIf="
                                !applyForm.get('email')?.pristine &&
                                !applyForm.get('email')?.hasError('required') &&
                                applyForm.get('email').hasError('email')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter a valid email address.
                        </div>
                    </div>
                    <div class="grow">
                        <label for="phone" class="block text-sm font-medium leading-6" i18n>Telephone Number</label>
                        <input
                            formControlName="phone"
                            placeholder="Telephone Number"
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <div *ngIf="job?.showLocationField" class="grow">
                        <label for="location" class="block text-sm font-medium leading-6" i18n>Your location</label>
                        <input
                            formControlName="location"
                            placeholder="Your Location"
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <div *ngIf="job?.showProfileField" class="grow">
                        <label for="location" class="block text-sm font-medium leading-6" i18n>Profile URL (e.g. LinkedIn)</label>
                        <input
                            formControlName="profileUrl"
                            placeholder="Your Profile URL"
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <div class="grow">
                        <label for="cv" class="block text-sm font-medium leading-6" i18n
                            >Your CV/Resume<sup *ngIf="!this.job.delayCvOnMobile">*</sup></label
                        >
                        <p
                            class="block text-sm font-medium leading-6"
                            *ngIf="applyForm.get('cv').value?.file?.originalName">
                            {{ applyForm.get("cv").value?.file.originalName }} uploaded
                            {{ applyForm.get("cv").value?.file.uploaded | date : "short" }}
                        </p>
                        <input type="file" name="cv" (change)="onFileUpload($event)" />
                        <div
                            *ngIf="!applyForm.pristine && applyForm.get('cv')?.hasError('required')"
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must upload your CV/Resume.
                        </div>
                    </div>
                    <div class="grow">
                        <label for="referral" class="block text-sm font-medium leading-6" i18n
                            >Do you have a referral code?</label
                        >
                        <input
                            formControlName="referral"
                            placeholder="Referral Code"
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="
                                !applyForm.get('referral')?.pristine &&
                                applyForm.get('referral').hasError('unrecognised')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter a valid email address.
                        </div>
                    </div>
                </div>
                <div *ngIf="sanitisedSkills.length" class="border-b border-gray-900/10 pb-8 mt-8">
                    <h3 class="font-bold text-lg" i18n>Level Of Experience</h3>
                    <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                        Please indicate your approximate level of experience in the following areas.
                    </p>
                    <div class="flex flex-col gap-4">
                        <div class="grow" *ngFor="let skill of sanitisedSkills; let i = index" formGroupName="skills">
                            <label for="seniorityType" class="block text-sm font-medium leading-6 text-gray-900">{{
                                job.skills[i]
                            }}</label>
                            <select
                                [formControlName]="skill"
                                class="mt-2 block w-full rounded-md border-0 h-10 p-2 pr-6 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                                <option [value]="1" i18n>No experience</option>
                                <option [value]="2" i18n>Some basic experience</option>
                                <option [value]="3" i18n>Average</option>
                                <option [value]="4" i18n>Advanced</option>
                                <option [value]="5" i18n>Expert</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div *ngIf="customQuestionsArr?.length" class="border-b border-gray-900/10 pb-8 mt-8">
                    <h3 class="font-bold text-lg" i18n>Additional screening questions</h3>
                    <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                        Please answer the following additional screening questions.
                    </p>
                    <div class="flex flex-col gap-4">
                        <div
                            *ngFor="let item of customQuestionsArr.controls; let i = index"
                            formArrayName="customQuestions">
                            <div *ngIf="item.get('type').value === 'text'" [formGroupName]="i">
                                <label for="answer" class="block text-sm font-medium leading-6 text-gray-900">{{
                                    item.get("question").value
                                }}</label>
                                <input
                                    formControlName="answer"
                                    placeholder="Your Answer"
                                    class="mt-2 block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                            </div>
                            <div
                                *ngIf="item.get('type').value === 'checkbox'"
                                [formGroupName]="i"
                                class="grow relative flex items-start">
                                <div class="flex h-6 items-center">
                                    <input
                                        type="checkbox"
                                        formControlName="answer"
                                        class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                                </div>
                                <div class="ml-3 text-sm leading-6">
                                    <label for="answer" class="text-sm font-medium leading-6">{{
                                        item.get("question").value
                                    }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col gap-4 pb-8 mt-8">
                    <div class="grow relative flex items-start" *ngIf="job.rightToWorkInUK">
                        <div class="flex h-6 items-center">
                            <input
                                type="checkbox"
                                formControlName="rightToWorkInUK"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label for="comments" class="text-sm font-medium leading-6" i18n
                                >Do you have the right to work in the advertised location?</label
                            >
                        </div>
                    </div>
                    <div *ngIf="job.showSimilarJobsConsent" class="grow relative flex items-start">
                        <div class="flex h-6 items-center">
                            <input
                                type="checkbox"
                                formControlName="relatedJobsConsent"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label for="comments" class="text-sm font-medium leading-6" i18n
                                >Can <span *ngIf="(client$ | async)?.onBehalfOf">{{(client$ | async).onBehalfOf}} </span>
                                <span *ngIf="!(client$ | async)?.onBehalfOf">{{ (client$ | async)?.displayName || (client$ | async)?.name }} </span> contact you
                                in the future about other roles similar to this?</label
                            >
                        </div>
                    </div>
                    <div class="grow relative flex items-start">
                        <div class="flex h-6 items-center">
                            <input
                                formControlName="terms"
                                type="checkbox"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label for="terms" class="font-medium text-gray-900" i18n
                                >I have read and agree to the terms of use and privacy statements.<sup>*</sup></label
                            >
                            <p class="text-gray-500"  *ngIf="(client$ | async)?.terms">
                                <span *ngIf="(client$ | async)?.onBehalfOf">{{(client$ | async).onBehalfOf}} are managing this role on behalf of {{ (client$ | async)?.displayName || (client$ | async)?.name }}. Their </span>
                                <span *ngIf="!(client$ | async)?.onBehalfOf">{{ (client$ | async)?.displayName || (client$ | async)?.name }}'s </span>
                                <a
                                    class="text-indigo-600 font-bold"
                                    [href]="(client$ | async)?.terms"
                                    rel="nofollow"
                                    target="_blank"
                                    >terms</a
                                >
                                can be found here.
                            </p>
                            <p class="text-gray-500">
                                Voyse's
                                <a
                                    class="text-indigo-600 font-bold"
                                    href="http://www.voyse.co.uk/terms"
                                    rel="nofollow"
                                    target="_blank"
                                    >terms</a
                                >
                                and
                                <a
                                    class="text-indigo-600 font-bold"
                                    href="http://www.voyse.co.uk/privacy"
                                    rel="nofollow"
                                    target="_blank"
                                    >privacy</a
                                >
                                 statements can be found here.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                <button
                    class="inline-flex items-center cursor-pointer disabled:bg-blue-300 disabled:text-white/50 disabled:cursor-not-allowed"
                    [ngClass]="applyButtonClasses"
                    [disabled]="submitting || applyForm.invalid"
                    (click)="apply()"
                    i18n>
                    <svg
                        *ngIf="submitting"
                        class="animate-spin -ml-1 mr-1 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24">
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"></circle>
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ job.active ? "Submit Application" : "Register Interest" }}
                </button>
            </div>
        </form>

        <div class="text-center prose" *ngIf="submitted && !finalised">
            <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6" i18n>How did we do?</h1>
            <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                Good luck with your application! How did you find your candidate experience using Voyse today? Please rate your experience as a candidate below.
            </p>
            <app-star-rating></app-star-rating>
        </div>

        <div class="text-center prose" *ngIf="submitted && finalised">
                <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6" i18n>Good luck!</h1>
                <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                    Thank you for submitting your application for the
                    <span class="font-bold">{{ job.title }}</span> position.
                </p>
                <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                    We really appreciate the time and effort you've invested in applying for this position and understand
                    the importance of this opportunity to you.
                </p>
                <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                    Rest assured; your application will be given the attention it deserves. If your skills and experience
                    align with our requirements, we will reach out to you to explain the next steps in the selection
                    process. In the interim, feel free to explore more about our company on our website to gain further
                    insight into our values and objectives.
                </p>
                <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                    Thank you once again for your application. We appreciate your patience and look forward to the
                    possibility of working together.
                </p>
        </div>
    </div>
</app-dialog-container>
